// extracted by mini-css-extract-plugin
export default {"napsa-header":"Header_napsa-header__vNc06","napsa-header__buttons":"Header_napsa-header__buttons__fARvJ"};